<template>
  <CustomForm />
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import CustomForm from "@/components/CustomForm.vue";
import "./styles.css";

export default defineComponent({
  name: "App",
  components: {
    CustomForm,
  },
  setup() {
    const firstName = ref("");
    return {
      firstName,
    };
  },
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
